import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
import { AppState } from '../../app/types';
import { GroupId } from '../../config/systemConfig';
import { Card } from '../ui/Card';
import { SectionHeader } from '../ui/SectionHeader';
import { itemVariants } from '../shared/animations';
import { useErrorPatterns } from '../../utils/errorPatterns';
import { RADIUS } from '../../config/designTokens';
// Re-export for any historic consumers that import from this file
// (audit DDD-3, ronde 2 2026 — implementation moved to
// `src/utils/errorPatterns.ts` so the mascot domain can consume it
// without depending on this progress UI module).
export { useErrorPatterns } from '../../utils/errorPatterns';
interface ErrorPatternsSectionProps {
  state: AppState;
  selectedGroup: GroupId;
}
export function ErrorPatternsSection({
  state,
  selectedGroup
}: ErrorPatternsSectionProps) {
  const errorPatterns = useErrorPatterns(state, selectedGroup);
  return <div className="space-y-4" data-id="element-1906" data-mp="d5b1bowivocu">
      <SectionHeader title="Slimme Leertips" icon={Lightbulb} accentColor="bg-violet-100 text-violet-600" data-id="element-1907" data-mp="d487p97tf7t8" />
      

      {errorPatterns.length === 0 ? <Card className={`p-6 text-center bg-slate-50 border-dashed border-2 border-slate-200 ${RADIUS.card} shadow-sm`} data-id="element-1908" data-mp="88szoxwho64q">
        
          <p className="text-slate-500 font-medium" data-id="element-1909" data-mp="h6wi3lc6gmsb">
            Geen specifieke tips — je doet het geweldig! 🌟
          </p>
        </Card> : <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1910" data-mp="3pnhn6r1ouvq5">
          {errorPatterns.map((pattern, i) => <motion.div key={`${pattern.errorType}-${i}`} variants={itemVariants} data-id="element-1911" data-mp="3lj9u6ho76tm4" data-mpi={i}>
          
              <Card className={`p-5 h-full flex flex-col border-2 border-slate-100 bg-white ${RADIUS.card} shadow-sm hover:shadow-md transition-shadow`} data-id="element-1912" data-mp="39gba8pyyr01">
            
                <div className="flex items-center gap-3 mb-3" data-id="element-1913" data-mp="36vf1v2e3qr9k">
                  <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-xl shadow-sm ${pattern.moduleColor.replace('bg-', 'bg-opacity-20 text-').replace('500', '700')} bg-opacity-20`} data-id="element-1914" data-mp="31xn6tzi5up15">
                
                    {pattern.moduleIcon}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1915" data-mp="1fk207v2bqcom">
                    <h4 className="font-bold text-slate-800 truncate" data-id="element-1916" data-mp="1fld3zuvrrkfq">
                      {pattern.familyName}
                    </h4>
                    <p className="text-xs text-slate-500 font-medium" data-id="element-1917" data-mp="1kky448modyu1">
                      Tip voor jou
                    </p>
                  </div>
                </div>
                <div className="bg-violet-50 rounded-xl p-4 flex-1" data-id="element-1918" data-mp="rupw39lusut6">
                  <p className="text-violet-800 text-sm font-medium leading-relaxed" data-id="element-1919" data-mp="wshlnwz104u7">
                    {pattern.recommendation}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </div>;
}